import axios from '..';
import { LOGIN_SUCCESS, LOGIN_FAILED } from '../../actionTypes';

export default (payload) => async (dispatch) => {
  try {
    const response = await axios.post('/providers/login', payload);
    const {
      data: {
        message,
        data: { token },
      },
    } = response;
    dispatch({
      type: LOGIN_SUCCESS,
      message,
      token,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: LOGIN_FAILED, error });
  }
};
